import React from 'react';
import Production from './Production';

export default (props) => {
  return(<Production {...props}/>);
};
